import React, { useEffect } from 'react'

const CustomScroll = props => {
    useEffect(() => {
        const el = document.getElementsByClassName('app-container')[0]

        try {
            el.style.maxHeight = 'none'
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            })
        } catch (error) {
            window.scrollTo(0, 0)
        }
        setTimeout(() => (el.style.maxHeight = '100vh'), 0)
    }, [])
    return <>{props.children}</>
}

export default CustomScroll
